import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnChanges,
  SimpleChanges,
  ViewEncapsulation,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { COLOR, ProgressBarStyle } from '../../constants';

@Component({
  selector: 'seech-shared-progress-bar',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './progress-bar.component.html',
  styleUrls: ['./progress-bar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
})
export class ProgressBarComponent implements OnChanges {
  @Input() color = COLOR.PRIMARY;
  @Input() progress = 0;
  @Input() min = 0;
  @Input() max = 100;
  @Input() isIndeterminate = false;
  @Input() height = '4px';
  @Input() borderRadius = '0px';
  @Input() shape: ProgressBarStyle = 'horizontal';

  classes = this.getProgressBackground();
  progressStrokeClass = this.getProgressStroke();

  indeterminateClasses = this.getIndeterminateProgressBackground();
  Math = Math;
  strokeColor = '';

  public get width(): string {
    // return `width: ${this.progress}%`;
    return this.shape === 'horizontal' ? `width: ${this.progress}%` : '';
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  ngOnChanges(changes: SimpleChanges): void {
    this.classes = this.getProgressBackground();
    this.indeterminateClasses = this.getIndeterminateProgressBackground();
    this.progressStrokeClass = this.getProgressStroke()
  }
  getProgressBackground() {
    return `bg-${this.color}`;
  }

  getProgressStroke() {
    return `progress-stroke-${this.color}`;
  }

  getIndeterminateProgressBackground() {
    return `indeterminate-${this.color}`;
  }

  get strokeDashoffset(): number {
    // Calculate the dashoffset for circular progress based on progress percentage
    const radius = 45; // Assuming a radius for the circular progress
    const circumference = 2 * Math.PI * radius;
    return circumference - (this.progress / 100) * circumference;
  }
}
